module.exports = __webpack_public_path__ + "fonts/NanumSquareRoundEB.5f0c29d.eot";